// extracted by mini-css-extract-plugin
export default {"buttonCount":"X2CGZWTb","_withBrackets":"VwdARC1M"};